import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { authApi } from '@/api'

export const useAuthStore = defineStore('auth', () => {
  const token        = ref(null)
  const userData     = ref(null)
  const userSettings = ref(null)
  const redirectUrl  = ref(null)

  function setRedirectUrl(url) {
    redirectUrl.value = url
  }

  function setSession({ user, userSettings: settings, token: t }) {
    userData.value     = user
    userSettings.value = settings
    token.value        = t
  }

  function login(payload) {
    return authApi.login(payload).then((body) => {
      const { data } = body
      setSession({ user: data.user, userSettings: data.userSettings, token: data.token })
      return body
    })
  }

  function logout() {
    userData.value      = null
    userSettings.value  = null
    token.value         = null
    redirectUrl.value   = null
  }

  const isLoggedIn        = computed(() => userData.value?.id ? true : false)
  const isGoogleConnected = computed(() => !!userSettings.value?.googleConnected)

  const currentUser = computed(() => {
    function hasRole(role) {
      const roles = userData?.value?.roles
      if (!roles) return false
      const found = roles.find(r => r.name == role)
      return found ? true : false
    }

    const userDataFields = computed(() => {
      return userData.value
    })

    const isAdmin = computed(() => hasRole('admin') )

    const isManager = computed(() => hasRole('dc') || hasRole('admin'))

    const isDc = computed(() => hasRole('dc'))

    const isDg = computed(() => hasRole('dg'))

    return {
      isLoggedIn,
      hasRole,
      isAdmin:   isAdmin.value,
      isManager: isManager.value,
      isDc:      isDc.value,
      isDg:      isDg.value,
      isGoogleConnected: isGoogleConnected.value,
      // extract userData fields
      ...userDataFields.value,
    }
  })

  // These methods allow patching user data and settings so we don't need
  // to reload the browser to see visual updates (see UserSettings page)
  function patchUserData(data) {
    userData.value     = data
  }

  function patchUserSettings(data) {
    userSettings.value = data
  }

  return {
    token,
    userData,
    userSettings,
    redirectUrl,
    currentUser,
    isLoggedIn,
    isGoogleConnected,
    login,
    logout,
    setSession,
    setRedirectUrl,
    patchUserData,
    patchUserSettings,
  }
}, { persist: { pick: ['userData', 'userSettings', 'token', 'redirectUrl'] } })
